import React, { useEffect, useState } from 'react';
import { motion, useSpring, useTransform } from 'framer-motion';
interface CountUpNumberProps {
  value: number;
  duration?: number;
  suffix?: string;
  prefix?: string;
  className?: string;
  delay?: number;
}
export function CountUpNumber({
  value,
  duration = 2,
  suffix = '',
  prefix = '',
  className = '',
  delay = 0
}: CountUpNumberProps) {
  const spring = useSpring(0, {
    duration: duration * 1000,
    bounce: 0
  });
  const displayValue = useTransform(spring, current => Math.round(current));
  const [hasStarted, setHasStarted] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setHasStarted(true);
      spring.set(value);
    }, delay * 1000);
    return () => clearTimeout(timer);
  }, [value, delay, spring]);
  return <motion.span className={className} data-id="element-254">
      {prefix}
      <motion.span data-id="element-255">{displayValue}</motion.span>
      {suffix}
    </motion.span>;
}